var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIEmailStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4928 28.9651L53.665 25.9381L44.3545 7.06273C44.1002 6.54593 43.6818 6.12757 43.165 5.87327C41.8689 5.23343 40.2939 5.76663 39.6459 7.06273L30.3353 25.9381L9.50761 28.9651C8.93339 29.0471 8.40839 29.3178 8.00643 29.728C7.5205 30.2274 7.25272 30.8994 7.26195 31.5962C7.27118 32.2929 7.55666 32.9576 8.05565 33.444L23.1248 48.1358L19.5646 68.8815C19.4812 69.3641 19.5346 69.8604 19.7188 70.3142C19.903 70.768 20.2107 71.161 20.607 71.4489C21.0033 71.7367 21.4722 71.9077 21.9608 71.9425C22.4493 71.9773 22.9378 71.8746 23.3709 71.6459L42.0002 61.8514L60.6295 71.6459C61.1381 71.9166 61.7287 72.0069 62.2947 71.9084C63.7221 71.6623 64.6818 70.3088 64.4357 68.8815L60.8756 48.1358L75.9447 33.444C76.3549 33.042 76.6256 32.517 76.7076 31.9428C76.9291 30.5073 75.9283 29.1784 74.4928 28.9651V28.9651Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIEmailStar);
export default __webpack_public_path__ + "static/media/i__email_star.be646adf02d3188fd3e0ecf6f6922fb5.svg";
export { ForwardRef as ReactComponent };